<template>
<div>
    <!-- modal -->
    <b-modal id="businessPartnerResponsibleFormModal" centered size="lg" no-close-on-backdrop ref="businessPartnerResponsibleFormModal" :title=" $t('businessPartnerResponsible.info')" :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate" @close="clear()">
        <b-form @submit.prevent="addOrUpdate">
            <b-button type="submit" style="display: none;"></b-button>
            <validation-observer ref="infoRules" tag="form">
                <b-row>
                    <b-col class="col-md-6 mt-1">
                        <label for="businessPartnerResponsible-name-input">{{ $t('businessPartnerResponsible.name') }}</label>
                        <b-form-group>
                            <validation-provider #default="{ errors }" :name=" $t('businessPartnerResponsible.name')" rules="required">
                                <b-form-input size="sm" id="businessPartnerResponsible-name-input" v-model="name" maxlength="50" :state="errors.length > 0 ? false:null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </b-col>
                    <b-col class="col-md-6 mt-1">
                        <label for="businessPartnerResponsible-surname-input">{{ $t('businessPartnerResponsible.surname') }}</label>
                        <b-form-group>
                            <validation-provider #default="{ errors }" :name=" $t('businessPartnerResponsible.surname')" rules="required">
                                <b-form-input size="sm" id="businessPartnerResponsible-surname-input" v-model="surname" maxlength="50" :state="errors.length > 0 ? false:null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="col-md-6 mt-1">
                        <label for="businessPartnerResponsible-email-input">{{ $t('businessPartnerResponsible.email') }}</label>
                        <b-form-group>
                            <validation-provider #default="{ errors }" :name=" $t('businessPartnerResponsible.email')" rules="required">
                                <b-form-input size="sm" id="businessPartnerResponsible-email-input" v-model="email" type="email" maxlength="50" :state="errors.length > 0 ? false:null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </b-col>
                    <b-col class="col-md-6 mt-1">
                        <label for="businessPartnerResponsible-telephone-input">{{ $t('businessPartnerResponsible.telephone') }}</label>
                        <b-form-group>
                            <validation-provider #default="{ errors }" :name=" $t('businessPartnerResponsible.telephone')" rules="required">
                                <b-form-input size="sm" id="businessPartnerResponsible-telephone-input" v-model="telephone" type="tel" maxlength="20" :state="errors.length > 0 ? false:null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </b-col>
                </b-row>
            </validation-observer>
        </b-form>
    </b-modal>
</div>
</template>

    
<script>
export default {
    props: {
        getBusinessPartnerResponsibleList: {
            type: Function
        },
        getBusinessPartnerList: {
            type: Function
        },
    },
    data() {
        return {
            id: 0,
            businessPartnerId: 0,
            name: '',
            surname: '',
            telephone: '',
            email: '',
        }
    },
    methods: {
        showInfo(id, businessPartnerId) {
            this.$refs['businessPartnerResponsibleFormModal'].show()
            this.id = id
            this.businessPartnerId = businessPartnerId
            const data = {
                id: this.id
            }
            const controller = {
                name: 'BusinessPartnerResponsible'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                this.name = response.data.businessPartnerResponsible.name
                this.surname = response.data.businessPartnerResponsible.surname
                this.telephone = response.data.businessPartnerResponsible.telephone
                this.email = response.data.businessPartnerResponsible.email

            })
        },
        addOrUpdate() {
            const data = {
                id: this.id,
                businessPartnerId: this.businessPartnerId,
                name: this.name,
                surname: this.surname,
                telephone: this.telephone,
                email: this.email
            }
            const controller = {
                name: 'BusinessPartnerResponsible'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$refs.infoRules.validate().then(success => {
                if (success) {
                    this.$store.dispatch('moduleAuth/save', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$bvModal.hide('businessPartnerResponsibleFormModal')
                            this.getBusinessPartnerResponsibleList()
                            this.$SaveAlert()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                    })
                }
            })
        },
        clear() {
            this.name = '',
                this.surname = '',
                this.telephone = '',
                this.email = ''
        }
    },
}
</script>

    
<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
</style>
